<template>
  <div v-show="activeTag!=='快速介绍公司'" class="tags borderbottom" style="overflow: hidden;">
    <span
      :class="`search_tab_item search_tab_item.tab_item_selected`"
      style="width:100%;background-color:#467388;color:#fff;"
      @click="showtTag('快速介绍公司')"
      >快速介绍公司（点击有惊喜）</span
    >
    <span v-if="company.网址" style="cursor: pointer;width: 100%;color: rgb(90, 162, 234);margin: 0 10px 8px 0;" @click="openWebsite(company.网址)">查看官网</span>
    <el-tooltip
      v-for="tag in companyTagsResult"
      :key="tag.label"
      popper-class="detail-tag-btn"
      :disabled="tag.hasValue"
      :visible-arrow="false"
      effect="dark"
      placement="top">
      <div slot="content">
        暂无信息，点击<i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充
      </div>
      <span
        :class="`search_tab_item ${tabClass(tag)}`"
        @click="showtTag(tag.label)"
        >{{ translateTag[tag.label] ||  tag.label }}</span
      >
    </el-tooltip>
    <!-- <span v-if="company._id" class="radish-btn radish-btn-primary radish-btn-small" @click="toCompany">进入公司</span> -->
    <span v-if="company._id" class="search_tab_item  tab_item_primary drawer-jump-btn" style="float: right;background-color:#046BB0" @click="toCompany">全屏展示</span>
  </div>
</template>
<script>
const tags = [
  { label: '面试相关', fields: ['面试安排', '面试流程','推荐备注','特殊要求寻访', '对接hr', '面试地址'] },
  { label: '薪酬职级', fields: ['薪酬/职级/奖金机制','薪酬logs','companyMoneyTable','categoryMoneyTable'] },
  { label: '领军人物', fields: ['领导介绍', '领导'] },
  { label: '用人偏好', fields: ['人员整体情况', 'tagsort', '用人偏好', '倾向学历备注', '倾向年龄', '倾向年龄备注', '倾向性别', '倾向性别备注', '倾向平台备注', '目标公司', '不倾向公司', '勿推荐公司', '典型人才'] },
  { label: '阿尔法认知', fields: ['公司备注'] },
  { label: '职能模块认知', fields: ['职能模块认知'] },
  { label: '特点/风格', fields: ['优势业务','业务特点/风格/资源来源', '人员风格'] },
  { label: '优势/劣势', fields: ['公司亮点', '公司劣势'] },
  { label: '人才画像分析', fields: ['analyse'] },
  { label: '公司评级', fields: ['平台等级', '排名', '行业', '公司类型', '公司性质', '人员受认可度', '激励机制', '固定薪酬', '人员稳定性', '币种', '管理规模',] },
  { label: '组织架构', fields: [''] },
  { label: '公司附件', fields: ['附件'] },
  { label: '问题及应对', fields: ['可能的问题及应对'] },
  // {
  //   label: '基本信息',
  //   fields: [
  //     '行业',
  //     '平台等级',
  //     '排名',
  //     '优势业务',
  //     '投资阶段',
  //     '总部所在地',
  //     '办公地',
  //     // '人员受认可度',
  //     // '固定薪酬',
  //     // '激励机制',
  //     // '人员稳定性',
  //     '网址',
  //   ],
  // },
  // { label: '公司简介', fields: ['一句话简介', '公司介绍','人员受认可度', '固定薪酬', '激励机制', '人员稳定性',] },
  // { label: '推荐须知', fields: ['特殊要求寻访', '推荐备注', '特殊要求面试安排'] },
]
const translateTag = {
  公司简介: '公司介绍',
}

// const translateTag = {
//   行业: '公司行业',
//   平台等级: '公司平台',
//   办公地: '主要办公地',
//   网址: '公司官网',
//   一句话简介: '一句话介绍',
//   '业务特点/风格/资源来源': '业务特点',
//   公司备注: '阿尔法认知',
//   特殊要求寻访: '特殊要求',
//   推荐备注: '推荐要求',
//   特殊要求面试安排: '面试安排',
//   '薪酬/职级/奖金机制': '薪酬概况',
//   领导介绍: '高管介绍',
// }

export default {
  props: {
    company: { type: Object, default: () => ({}) },
    activeTag: { type: String, default: '' },
  },
  data() {
    return {
      companyTagsResult: [],
      translateTag:translateTag,
    }
  },
  watch: {
    company: {
      handler(newValue, oldValue) {
        this.computedTags()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    toCompany() {
      window.open(`${window.origin}#/company/${this.company._id}`)
    },
    computedTags() {
      const arr = []
      tags.forEach(tag => {
        const hasValue = tag.label === '组织架构' ? true : this.checkTagFields(tag.fields)
        arr.push({ label: tag.label, hasValue })
      })
      this.companyTagsResult = arr
    },
    checkTagFields(fields) {
      const { company } = this
      for (const field of fields) {
        const hasValue = this.hasValue(field, company[field])
        if (hasValue) return true
      }
      return false
    },
    hasValue(field, value) {
      if (!value) return false
      const specialFields = ['公司亮点', '公司劣势', '业务特点/风格/资源来源']
      if(field==='可能的问题及应对'){
        const arr = (value || []).filter(a=>a.Q || a.A)
        return arr.length>0
      }else if (!specialFields.includes(field)) {
        if (Array.isArray(value) && value.length > 0) return true
        else if (!Array.isArray(value) && value) return true
      } else {
        const { content = '', keywords = {} } = value || {}
        if (content) return true
        const arr = Object.values(keywords)
        return arr.includes(true)
      }
      return false
    },
    tabClass(tag) {
      let result = ''
      if (this.activeTag === tag.label) {
        result += 'tab_item_selected'
      }
      if (tag.hasValue) result += ' tab_item_primary'
      else result += ' tab_item_default'
      return result
    },
    showtTag(label) {
      // this.activeTag = label
      this.$emit('chooseTag', label)
    },
    openWebsite(str){
      const val = str ? str.replace(/[,，;；]/g, ';') : ''
      const arr = val
        .split(';')
        .filter(v => v)
        .map(v => (v.includes('http') ? v : `http://${v}`))
      if(arr[0])window.open(arr[0])
      else this.$message.error('网址错误')
    },
  },
}
</script>
<style>
.el-tooltip__popper.detail-tag-btn.is-dark {
  background: rgb(48 49 51 / 59%);
}
</style>
<style scoped>
.borderbottom {
  padding-bottom: 5px;
  /* border-bottom: 1px solid #eee; */
}
.search_tab_item {
  display: inline-block;
  cursor: pointer;
  margin: 0 10px 8px 0;
  padding: 4px 12px;
  border-radius: 2px;
  min-width: 76px;
  text-align: center;
}
.drawer-jump-btn {
  background-color: #409eff;
  color: #fff;
}
.tab_item_primary {
  color: #fff;
  background-color: #8DB9CE;
}
.search_tab_item.tab_item_default{
  color: #909399;
  background-color: hsla(220,4%,58%,.1);
  text-decoration: line-through;
}
.search_tab_item.tab_item_selected {
  background-color:#4B7A90;
  color:#fff;
}
</style>
